// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../imgs/blob-blue-duo-2x.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oicLuXVk42cO7KCjJ3zZ {
  background-color: var(--date-color);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position-x: right;
  background-position-y: 10%;
  background-size: auto 90%;
  background-repeat: no-repeat;

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  color: var(--white-color);
}

.NHHs_VdX0YU2XfcxqMLO {
  width: 90%;
  max-width: 90rem;
  text-align: left;
  padding: 3rem;
  border-radius: 2rem;
  background-color: var(--dk-grey-color);
}

.NHHs_VdX0YU2XfcxqMLO h2 {
  font-size: var(--step-2);
  text-align: center;
}

.NHHs_VdX0YU2XfcxqMLO h2::before {
  padding-right: 0.5rem;
  content: "\\f304";
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
}

.NHHs_VdX0YU2XfcxqMLO h3 {
  padding-top: 3rem;
  font-size: var(--step-1);
}

.NHHs_VdX0YU2XfcxqMLO a {
  color: var(--date-color);
}

.NHHs_VdX0YU2XfcxqMLO a[href*="youtube.com"]::after {
  font-family: "Font Awesome 6 Free";
  font-weight: 900;

  padding-left: 0.5rem;
  content: "\\f04b";
  color: mediumorchid;
}

.NHHs_VdX0YU2XfcxqMLO p {
  padding-bottom: 1rem;

  line-height: var(--base-line-height);
}

.NHHs_VdX0YU2XfcxqMLO p img {
  border-radius: 0.5rem;
}

.NHHs_VdX0YU2XfcxqMLO div[role="figure"] img {
  margin-top: 2rem;
  border-radius: 8px;
  margin-bottom: 0.5rem;
}

.NHHs_VdX0YU2XfcxqMLO div[role="figure"] {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.NHHs_VdX0YU2XfcxqMLO ol {
  padding-left: 2rem;
  margin: 1rem 0;
  counter-reset: list-counter;
}

.NHHs_VdX0YU2XfcxqMLO ol li {
  position: relative;

  padding-left: 2rem;
}

.NHHs_VdX0YU2XfcxqMLO ol li strong {
  margin-right: 0.5rem;
}

@media only screen and (max-width: 1000px) {
  .oicLuXVk42cO7KCjJ3zZ {
    background-color: var(--dk-grey-color);
  }

  .NHHs_VdX0YU2XfcxqMLO {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/FeaturedTopicPage/FeaturedTopicPage.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,yDAAsD;EACtD,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;;EAE5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;;EAEhB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;;EAEpB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;;EAElB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,sCAAsC;EACxC;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".featuredTopicPage {\n  background-color: var(--date-color);\n  background-image: url(../../imgs/blob-blue-duo-2x.png);\n  background-position-x: right;\n  background-position-y: 10%;\n  background-size: auto 90%;\n  background-repeat: no-repeat;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 2rem;\n  color: var(--white-color);\n}\n\n.container {\n  width: 90%;\n  max-width: 90rem;\n  text-align: left;\n  padding: 3rem;\n  border-radius: 2rem;\n  background-color: var(--dk-grey-color);\n}\n\n.container h2 {\n  font-size: var(--step-2);\n  text-align: center;\n}\n\n.container h2::before {\n  padding-right: 0.5rem;\n  content: \"\\f304\";\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 900;\n}\n\n.container h3 {\n  padding-top: 3rem;\n  font-size: var(--step-1);\n}\n\n.container a {\n  color: var(--date-color);\n}\n\n.container a[href*=\"youtube.com\"]::after {\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 900;\n\n  padding-left: 0.5rem;\n  content: \"\\f04b\";\n  color: mediumorchid;\n}\n\n.container p {\n  padding-bottom: 1rem;\n\n  line-height: var(--base-line-height);\n}\n\n.container p img {\n  border-radius: 0.5rem;\n}\n\n.container div[role=\"figure\"] img {\n  margin-top: 2rem;\n  border-radius: 8px;\n  margin-bottom: 0.5rem;\n}\n\n.container div[role=\"figure\"] {\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n}\n\n.container ol {\n  padding-left: 2rem;\n  margin: 1rem 0;\n  counter-reset: list-counter;\n}\n\n.container ol li {\n  position: relative;\n\n  padding-left: 2rem;\n}\n\n.container ol li strong {\n  margin-right: 0.5rem;\n}\n\n@media only screen and (max-width: 1000px) {\n  .featuredTopicPage {\n    background-color: var(--dk-grey-color);\n  }\n\n  .container {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featuredTopicPage": `oicLuXVk42cO7KCjJ3zZ`,
	"container": `NHHs_VdX0YU2XfcxqMLO`
};
export default ___CSS_LOADER_EXPORT___;
